import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  DataTable, Table, TableBody, TableCell, TableContainer,
  TableHead, TableHeader, TableRow, TableToolbar, TableToolbarContent,
  TableToolbarSearch, Button, Pagination
} from '@carbon/react';
import { useSorting } from '../../modules/hooks/sorting';

const TrucksTable = props => {
  const { data } = props
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const convertToCSV = (data) => {
    // Define the mapping between the table headers and the object keys in `data`
    const headerMapping = {
      truckPatent: 'Patente',
      device_id: 'Id dispositivo',
      group: 'Tipo de equipo y marca',
      currTime: 'Fecha último dato',
      geofence_name: 'Geocerca',
      ecu_fuel_level_real: 'Nivel de Combustible %',
      ecu_def_level: 'Nivel de fluido de escape Diesel %',
      curr_operador: 'Operador',
      ib: 'iButton',
      owner: 'Proveedor'
    };

    if (data.length === 0) {
      return '';
    }

    const headers = Object.values(headerMapping).join(',') + '\n';
    const rows = data.map(row => {
      return Object.keys(headerMapping).map(key => {
        let value = row[key];
    
        // Handle null or undefined values
        if (value === null || value === undefined) {
          value = ''; // Replace null/undefined with an empty string
        } else if (!isNaN(value) && typeof value === 'number' && value.toString().includes('.')) {
          // If it's a number with a dot, replace the dot with a comma
          value = value.toString().replace('.', ',');
        }
    
        return `"${value}"`; // Apply text formatting to all fields
      }).join(',');
    }).join('\n');

    return headers + rows;
  };

  const downloadCSV = (csvContent, fileName = 'download.csv') => {
    // Create a Blob with the CSV content
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    // Create a hidden link element
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);

    // Append link to the body, click it, and then remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = () => {
    const csv = convertToCSV(data);

    downloadCSV(csv, 'Camiones.csv');
  };

  const headerData = [
    {
      header: 'Patente', // Truck Patent
      key: 'truckPatent',
    },
    {
        header: 'Id dispositivo', // Time Category
        key: 'device_id',
    },
    {
        header: 'Tipo de equipo y marca', // Type of vehicle
        key: 'group',
    },
    {
      header: 'Fecha último dato', // Time Category
      key: 'currTime',
      sortDirection: 'DESC', // Sort descending by default
      isDefaultSortable: true
    },
    {
      header: 'Estado', // Operator name
      key: 'time_category',
    },
    {
      header: 'Geocerca', // ECU Distance in km
      sortDirection: 'DESC', // Sort descending by default
      key: 'geofence_name',
    },
    {
      header: 'Nivel de Combustible %', // ECU Distance in km
      key: 'ecu_fuel_level_real',
      sortDirection: 'DESC', // Sort descending by default
    },
    {
      header: 'Nivel de fluido de escape Diesel %', // ECU Distance in km
      key: 'ecu_def_level',
      sortDirection: 'DESC', // Sort descending by default
    },
    {
      header: 'Operador', // Operador
      sortDirection: 'DESC', // Sort descending by default
      key: 'curr_operador',
    },
    {
      header: 'iButton', // Operador
      key: 'ib',
    },
    {
      header: 'Proveedor', // Operador
      key: 'owner',
    },

  ];  
  
  const { rows, headers } = useSorting(data, headerData);

  const Default = () => <DataTable rows={rows} headers={headers} isSortable>
    {({
      rows,
      headers,
      getHeaderProps,
      getRowProps,
      getTableProps,
      getTableContainerProps,
      onInputChange,
      sortBy
    }) => <TableContainer {...getTableContainerProps()}>
        <TableToolbar>
          <TableToolbarContent>
            {/* pass in `onInputChange` change here to make filtering work */}
            <TableToolbarSearch onChange={onInputChange} />
            <Button onClick={handleDownload} >Descargar</Button>
          </TableToolbarContent>
        </TableToolbar>
        <Table {...getTableProps()} aria-label="sample table">
          <TableHead>
            <TableRow>
              {headers.map((header, i) => <TableHeader
                key={i}
                sortDirection={headerData[i]?.sortDirection ?? "NONE"}
                {...getHeaderProps({
                  header,
                  isSortable: (headerData[i]?.sortDirection ?? "NONE") !== "NONE",
                  onClick: (_, sortState) => sortBy(sortState.sortHeaderKey)
                })}>
                {header.header}
              </TableHeader>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice((page - 1) * pageSize, page * pageSize).map(row => <React.Fragment key={row.id}>
              <TableRow {...getRowProps({
                row
              })}>
                {row.cells.map(cell => <TableCell key={cell.id}>{cell.value}</TableCell>)}
              </TableRow>
            </React.Fragment>)}
          </TableBody>
        </Table>
        <Pagination
            totalItems={rows.length}
            pageSizes={[10, 15, 20]}
            itemsPerPageText="Elementos por página"
            pageRangeText={(current, total) => `${current}–${total} página(s)`}
            itemRangeText={(min, max) => `${min}–${max} Filas`}
            pageNumberText="Número de página"
            page={page}
            pageSize={pageSize}
            onChange={({ page, pageSize }) => {
                setPage(page);
                setPageSize(pageSize);
            }}
            forwardText="Página siguiente"
            backwardText="Página anterior"
        />
      </TableContainer>}
  </DataTable>;

  return (
    <Default />
  )
}

TrucksTable.propTypes = {
  data: PropTypes.array
}

export default TrucksTable;